export const INDEX_ACTIVITIES = "activities"
export const INDEX_BOOKINGS = "bookings"
export const INDEX_PHOTOS = "photos"
export const INDEX_USERS = "users"
export const INDEX_HASHTAGS = "hashtags"
